<header class="border-bottom py-0">
    <nav class="navbar navbar-expand-md" aria-label="Fourth navbar example">
        <div class="container-fluid">
            <div class="navbar-brand d-none d-md-inline-flex">
                @if (!company?.id || company?.primary) {
                    <a
                        routerLink="/"
                        class="d-flex align-items-center my-2 my-lg-0 me-lg-auto text-decoration-none"
                        [title]="'Начало' | transloco"
                    >
                        <img src="/assets/img/logos/logo.svg" alt="" />
                    </a>
                    <a
                        [href]="
                            'tel:' +
                            ((company?.phone?.length
                                ? company?.phone
                                : '+359889990030'
                            ) | phone)
                        "
                        class="contact-number d-flex align-items-center"
                        [title]="'Телефон за връзка' | transloco"
                    >
                        <div class="row g-0">
                            <div
                                class="col-auto align-items-center me-2 d-none d-lg-inline-flex"
                            >
                                <i class="fa-solid fa-phone fa-fw fa-lg"></i>
                            </div>
                            <div class="col" style="max-width: 180px">
                                <div class="row">
                                    <div class="col-12">
                                        {{ "Телефон за контакти:" | transloco }}
                                    </div>
                                    <div
                                        class="col-12 fw-bold text-nowrap phone text-truncate"
                                    >
                                        {{
                                            company?.phone ?? "+359 889 990 030"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                } @else {
                    <a
                        routerLink="/"
                        class="d-flex align-items-center my-2 my-lg-0 me-lg-auto text-decoration-none custom-logo"
                        [title]="'Начало' | transloco"
                    >
                        @if (company?.id) {
                            <img [src]="company?.logo" alt="" />
                        }
                    </a>
                    @if (company?.phone?.length) {
                        <a
                            [href]="'tel:' + (company?.phone | phone)"
                            class="contact-number d-flex align-items-center"
                            [title]="'Телефон за връзка' | transloco"
                        >
                            <div class="row g-0">
                                <div
                                    class="col-auto align-items-center me-2 d-none d-lg-inline-flex"
                                >
                                    <i
                                        class="fa-solid fa-phone fa-fw fa-lg"
                                    ></i>
                                </div>
                                <div class="col" style="max-width: 180px">
                                    <div class="row">
                                        <div class="col-12">
                                            {{
                                                "Телефон за контакти:"
                                                    | transloco
                                            }}
                                        </div>
                                        <div
                                            class="col-12 fw-bold text-nowrap phone text-truncate"
                                        >
                                            {{ company?.phone }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    }
                }
            </div>

            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
            >
                <i class="fa-solid fa-bars"></i>
            </button>

            <app-language-switcher
                mode="dropdown"
                class="me-auto d-md-none lang-switcher mobile"
            ></app-language-switcher>

            <div
                class="justify-content-end d-block d-md-none d-lg-none d-xl-none"
            >
                <ul class="navbar-nav flex-row align-items-center gap-1">
                    @if (!navStoreHide) {
                        <li class="nav-item">
                            <a routerLink="/store" class="px-2">
                                <div class="fa-solid fa-cart-shopping fa-fw position-relative" [class.bounce]="notificationOrdersCount > 0">
                                    @if (notificationOrdersCount > 0) {
                                        <span class="notification-indicator" [class.smaller]="notificationOrdersCount > 99">
                                            {{ notificationOrdersCount < 100 ? notificationOrdersCount : "99+" }}
                                        </span>
                                    }
                                </div>
                            </a>
                        </li>
                    }
                    @if (!navCalendarHide) {
                        <li class="nav-item">
                            <a routerLink="/calendar" class="px-2">
                                <i class="fa-solid fa-bell fa-fw"></i>
                            </a>
                        </li>
                    }
                    @if (!navMessagesHide) {
                        <li class="nav-item">
                            <a routerLink="/messages" class="px-2">
                                <div class="fa-solid fa-envelope fa-fw position-relative" [class.bounce]="notificationMessageCount > 0">
                                    @if (notificationMessageCount > 0) {
                                        <span class="notification-indicator" [class.smaller]="notificationMessageCount > 99">
                                            {{ notificationMessageCount < 100 ? notificationMessageCount : "99+" }}
                                        </span>
                                    }
                                </div>
                            </a>
                        </li>
                    }
                    <li class="nav-item ms-3 me-1 mx-lg-3">
                        <a
                            href="#"
                            class="d-flex d-flex align-items-center justify-content-end text-decoration-none profile"
                            id="profileDropdownMenu"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <avatar [user]="user" size="tiny"></avatar>
                        </a>

                        <ul
                            class="dropdown-menu dropdown-menu-end text-small shadow position-absolute"
                            aria-labelledby="profileDropdownMenu"
                        >
                            <li>
                                <a
                                    class="dropdown-item"
                                    routerLink="/profile"
                                    >{{ "Профил" | transloco }}</a
                                >
                            </li>
                            <li><hr class="dropdown-divider" /></li>
                            @if (user && (user | roleAny: "partner")) {
                                <li>
                                    <a
                                        class="dropdown-item"
                                        routerLink="/company"
                                        >{{ "Фирмени данни" | transloco }}</a
                                    >
                                </li>
                                <li><hr class="dropdown-divider" /></li>
                            }
                            <li>
                                <a
                                    class="dropdown-item"
                                    routerLink="/auth/logout"
                                    >{{ "Изход" | transloco }}</a
                                >
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div class="collapse navbar-collapse justify-content-end">
                <ul class="navbar-nav">
                    <!-- <a href="tel:+359889990030" class="nav-item mx-3 text-white" [title]="'Телефон за връзка' | transloco">
                        <div class="row g-0">
                            <div class="col-auto align-items-center flex-row me-2 d-none d-lg-inline-flex">
                                <i class="fa-solid fa-phone fa-fw fa-2x"></i>
                            </div>
                            <div class="col-12" style="max-width: 180px">
                                <div class="row">
                                    <div class="col-12">{{ 'Телефон за контакти:' | transloco }}</div>
                                    <div class="col-12  fw-bold text-nowrap" style="font-size: 18px;">+359 889 990 030</div>
                                </div>
                            </div>
                        </div>
                    </a> -->
                    <li class="nav-item mx-3">
                        <app-language-switcher
                            mode="dropdown"
                            class="lang-switcher me-4"
                        ></app-language-switcher>
                    </li>
                    @if (!navStoreHide) {
                        <li class="nav-item mx-2 d-flex align-items-center">
                            <a routerLink="/store">
                                <div class="fa-solid fa-cart-shopping fa-fw fa-lg position-relative" [class.bounce]="notificationOrdersCount > 0">
                                    @if (notificationOrdersCount > 0) {
                                        <span class="notification-indicator" [class.smaller]="notificationOrdersCount > 99">
                                            {{ notificationOrdersCount < 100 ? notificationOrdersCount : "99+" }}
                                        </span>
                                    }
                                </div>
                            </a>
                        </li>
                    }
                    @if (!navCalendarHide) {
                        <li class="nav-item mx-2 d-flex align-items-center">
                            <a routerLink="/calendar">
                                <i class="fa-solid fa-bell fa-fw fa-lg"></i>
                            </a>
                        </li>
                    }
                    @if (!navMessagesHide) {
                        <li class="nav-item mx-2 d-flex align-items-center">
                            <a routerLink="/messages">
                                <div class="fa-solid fa-envelope fa-fw fa-lg position-relative" [class.bounce]="notificationMessageCount > 0">
                                    @if (notificationMessageCount > 0) {
                                        <span class="notification-indicator" [class.smaller]="notificationMessageCount > 99">
                                            {{ notificationMessageCount < 100 ? notificationMessageCount : "99+" }}
                                        </span>
                                    }
                                </div>
                            </a>
                        </li>
                    }
                    <li class="nav-item">
                        <a
                            href="#"
                            class="d-flex d-flex h-100 align-items-center justify-content-end text-decoration-none dropdown-toggle profile"
                            id="profileDropdownMenu"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <div class="d-flex align-items-start ms-2">
                                <div class="mx-2 text-end text user-name">
                                    {{ user | userName }}
                                    <small class="d-block user-role-title">{{
                                        user?.role?.title
                                    }}</small>
                                </div>
                                <avatar [user]="user"></avatar>
                            </div>
                        </a>
                        <ul
                            class="dropdown-menu dropdown-menu-end text-small shadow"
                            aria-labelledby="profileDropdownMenu"
                        >
                            <li>
                                <a
                                    class="dropdown-item"
                                    routerLink="/profile"
                                    >{{ "Профил" | transloco }}</a
                                >
                            </li>
                            <li><hr class="dropdown-divider" /></li>
                            @if (user && (user | roleAny: "partner")) {
                                <li>
                                    <a
                                        class="dropdown-item"
                                        routerLink="/company"
                                        >{{ "Фирмени данни" | transloco }}</a
                                    >
                                </li>
                                <li><hr class="dropdown-divider" /></li>
                            }
                            <li>
                                <a
                                    class="dropdown-item"
                                    routerLink="/auth/logout"
                                    >{{ "Изход" | transloco }}</a
                                >
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <div
        class="offcanvas offcanvas-start"
        tabindex="-1"
        id="offcanvasExample"
        aria-labelledby="offCanvasSidebar"
    >
        <div class="offcanvas-header">
            <h5 class="offcanvas-title mb-0" id="offCanvasSidebar">
                @if (!company?.id || company?.primary) {
                    <img
                        src="/assets/img/logos/logo.svg"
                        alt=""
                        class="company-logo"
                    />
                } @else {
                    <img [src]="company?.logo" alt="" class="company-logo" />
                }
            </h5>

            <button
                type="button"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                class="btn btn-default rounded-0 border-0 py-1 px-2 close-btn"
            >
                <i class="fa-lg fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="offcanvas-body">
            <ul class="nav nav-pills nav-flush flex-column mb-auto border-top">
                @for (group of navigationGroups; track group.title; let first = $first) {
                    @if (!first) {
                        <li class="nav-item mt-1">
                            <div class="border-top pt-2"></div>
                        </li>
                    }
                    @if (group.title) {
                        <li class="nav-item mt-1">
                            <div class="px-2 small text-body-tertiary text-uppercase fw-semibold">{{ group.title }}</div>
                        </li>
                    }
                    @for (menu of group.items; track menu.originalTitle) {
                        <li class="nav-item mt-1">
                            <a
                                href="#"
                                class="nav-link py-2 ps-3 pe-2 position-relative"
                                [class.bg-light]="menu?.notifications?.length"
                                aria-current="page"
                                [title]="menu.title"
                                [routerLink]="menu.url"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="
                                    menu.options || { exact: false }
                                "
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            >
                                @if (menu?.notifications?.length) {
                                    <span
                                        class="notification-indicator"
                                        [class.smaller]="
                                            +(menu?.notifications || '') > 99
                                        "
                                        >{{ menu?.notifications }}</span
                                    >
                                }
                                <i
                                    [class]="menu.icon"
                                    [class.text-danger]="
                                        menu?.notifications?.length
                                    "
                                ></i>
                                {{ menu.title }}
                            </a>
                        </li>
                    }
                }

                <li class="nav-item mt-1">
                    <div class="border-top pt-2"></div>
                </li>

                @if (!company?.id || company?.primary) {
                    <li class="nav-item mt-1">
                        <a
                            [href]="'tel:' + ('+359889990030' | phone)"
                            class="nav-link py-3 px-2 side-social-icon"
                            data-bs-toggle="tooltip"
                            data-bs-placement="right"
                            target="_blank"
                        >
                            <i class="fa-solid fa-phone-volume fa-fw"></i>
                            {{ "Телефон" | transloco }}
                        </a>
                    </li>
                    <li class="nav-item mt-1">
                        <a
                            href="https://www.facebook.com/advanceacademy.bg"
                            class="nav-link py-3 px-2 side-social-icon"
                            data-bs-toggle="tooltip"
                            data-bs-placement="right"
                            target="_blank"
                        >
                            <i class="fa-fw fa-brands fa-facebook-f"></i>
                            {{ "Facebook" | transloco }}
                        </a>
                    </li>
                } @else {
                    @if (company?.phone?.length) {
                        <li class="nav-item mt-1">
                            <a
                                [href]="'tel:' + (company?.phone | phone)"
                                class="nav-link py-3 px-2 side-social-icon"
                                data-bs-toggle="tooltip"
                                data-bs-placement="right"
                                target="_blank"
                            >
                                <i class="fa-solid fa-phone-volume fa-fw"></i>
                                {{ "Телефон" | transloco }}
                            </a>
                        </li>
                    }

                    @if (company?.facebook?.length) {
                        <li class="nav-item mt-1">
                            <a
                                [href]="company?.facebook"
                                class="nav-link py-3 px-2 side-social-icon"
                                data-bs-toggle="tooltip"
                                data-bs-placement="right"
                                target="_blank"
                            >
                                <i class="fa-fw fa-brands fa-facebook-f"></i>
                                {{ "Facebook" | transloco }}
                            </a>
                        </li>
                    }
                }
            </ul>
        </div>
    </div>
</header>
